import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Empresa, LoginFuncionario, Usuario} from '../models/interfaces';
import {Permissao} from '../shared/principal/permissoes-ezpoint/models/permissao';
import {retry} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AuthenticationResult} from '@azure/msal-browser';
import {AzureAdConfigs} from '../utils/azure-ad-configs';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  public dadosEmpresa!: Empresa;

  constructor(private http: HttpClient) {
  }

  buscaLogins() {
    return this.http.get<Usuario[]>('api/v1/login');
  }

  loginAdmin(usuario: Usuario) {
    return this.http.post<Usuario>('api/v1/login', usuario);
  }

  loginPonto(usuario: LoginFuncionario) {
    return this.http.post<LoginFuncionario>('api/v1/ponto/login', usuario);
  }

  loginAd(auth: AuthenticationResult) {
    return this.http.post<LoginFuncionario>('api/v1/ponto/login/ad', auth);
  }

  loginAdminAd(usuario: AuthenticationResult) {
    return this.http.post<Usuario>('api/v1/login/ad', usuario);
  }

  loginPontoAtualiza(usuario: LoginFuncionario) {
    return this.http.put<LoginFuncionario>(
      `api/v1/ponto/login/${usuario.pis}`,
      usuario
    );
  }

  loginPontoAtualizaCadastro(pis: string) {
    return this.http.get<LoginFuncionario>(`api/v1/ponto/login/${pis}`);
  }

  loginClienteAtualiza(usuario: Usuario) {
    return this.http.put<Usuario>(`api/v1/login/${usuario.login}`, usuario);
  }

  checkRecaptcha() {
    return this.http.get<boolean>(`api/v1/util/check`);
  }

  checkLogo() {
    return this.http.get<string>(`api/v1/util/logo`);
  }

  checkad() {
    return this.http.get<boolean>(`api/v1/util/check-ad`);
  }

  dadosAd() {
    return this.http.get<AzureAdConfigs>(`api/v1/util/dados-ad`);
  }

  checkEz() {
    return this.http.get<boolean>(`api/v1/util/ez`);
  }

  buscarModeloPermissao() {
    return this.http.get<Permissao[]>(`api/v1/util/model-perm`).pipe(
      retry(1),
      catchError(() => {
        throw new Error('Erro');
      })
    );
  }

  salvarModeloPermissao(permissoes: Permissao[]) {
    return this.http.post<Permissao[]>(`api/v1/util/model-perm`, permissoes).pipe(
      retry(1),
      catchError(() => {
        throw new Error('Erro');
      })
    );
  }

  Logado(): boolean {
    let c = localStorage.getItem('Usuario');
    let p = localStorage.getItem('Ponto');
    if (c !== null) {
      return true;
    } else if (p !== null) {
      return true;
    }
    return false;
  }

  Logout() {
    localStorage.removeItem('Usuario');
    localStorage.removeItem('Ponto');
  }

  buscaDadosEmpresa() {
    return this.http.get<Empresa[]>('api/v1/empresa');
  }

  buscaDadosEmpresaPw() {
    return this.http.get<Empresa>('api/v1/empresa/pw');
  }

  salvaDadosEmpresa(emp: Empresa) {
    return this.http.post('api/v1/empresa', emp);
  }

  SalvarUsuario(usuario: Usuario) {
    return this.http.post<Usuario>('api/v1/login/criar', usuario);
  }

  DeletarUsuario(usuario: Usuario) {
    return this.http.delete<Usuario>(`api/v1/login/${usuario.idd}`);
  }

  EsqueceuSenha(email: string) {
    return this.http.post<boolean>(`api/v1/util/esqueceu`, [email]);
  }
}
